import {hide_loader, show_loader} from './loaderAction';

const loaderInitState = {
    isLoaderShow: false
}


export default function handleLoader(state = loaderInitState, action) {
    switch (action.type) {
        case show_loader:
            return {...state, isLoaderShow: true}

        case hide_loader:
            return {...state, isLoaderShow: false}

        default:
            return state
    }
}
